/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface WorkerEquipmentModelResponse { 
    modelName?: string | null;
    modelCode?: string | null;
    serialNumber?: string | null;
}

